import { type MachineType } from "@packsize/schemas/machines";

export const machineAuditTypes: Partial<Record<MachineType, string>> = {
	CVPRange: "CVPRange",
	Em: "Em",
	Fusion: "Fusion",
	LantechCaseSealer: "LantechCaseSealer",
	PL1: "PL1",
	SealProX: "SealProX",
	X4: "X4",
	X5: "X5",
	X6: "X6",
	X7: "X7",
	ZebraPrinter: "Zebra",
};
